import { Colors, GridBreakpointsMediaDown, GridBreakpointsMediaUp } from '@dbi-tools/ui-kit';
import { ImgStyled } from '@dbi-tools/ui-kit/lib/img';
import styled from 'styled-components';

export const MainWhiteStyled = styled('div')<{ groomsmen?: boolean }>`
  ${GridBreakpointsMediaUp.lg} {
    background-color: ${Colors.white};
    padding: 30px;
  }
  ${GridBreakpointsMediaDown.md} {
    padding: 0 5px;
  }
  ${({ groomsmen }) =>
    groomsmen &&
    `
    position: relative;
    ${GridBreakpointsMediaUp.lg} {
      padding-right: 120px !important;
    }
    ${GridBreakpointsMediaDown.lg} {
      padding-right: 55px !important;
    }
    
    ${ImgStyled} {
      position: absolute;
      ${GridBreakpointsMediaUp.lg} {
        top: 30px;
        right: 30px;
      }
      ${GridBreakpointsMediaDown.lg} {
        top: 0;
        right: 5px;
        height: 40px;
      }
    }
  `}
`;
